import { useContext, useEffect } from "react";
import { Outlet, useLocation } from 'react-router-dom';
import SearchContext from 'src/context/SearchContext';
import Footer from 'src/components/Footer';
import Header from 'src/components/Header';

export default function Default() {

    const {error} = useContext(SearchContext);
    const location = useLocation()
    useEffect(() => {
        console.log('Location.pathname', location.pathname)
    }, [location])

    return (
        <div className="page">
            <Header showBar={location.pathname != '/'}/>
            <Outlet/>
            <Footer />
            {error && <div className="error-msg"><h2>{error}</h2></div>}
        </div>
    )
}  
